export const testimonials = [
  {
    name: 'Isabella Vargas',
    role: 'Pediatric OT',
    location: 'Bogotá, Colombia',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/cc868b1f-3172-4912-a393-73138741627a.jpg',
    quote:
      'I used to finish sessions with pages of notes and no clear thread. The pathway made me separate what I actually observed from what I was assuming. My case summaries are shorter and far more useful now.',
  },
  {
    name: 'Danielle Brooks',
    role: 'Pediatric OT, school-based',
    location: 'Atlanta, USA',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/585d2eac-3dfa-4b64-b86a-a7ec1fe254a7.jpg',
    quote:
      'The Missing Information Filter alone changed how I prepare for team meetings. I can explain what I know, what I’m still exploring, and why.',
  },
  {
    name: 'Mateo Rojas',
    role: 'Pediatric OT',
    location: 'Santiago, Chile',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c5395c94-679f-4ba3-95d3-5bb5444f28ba.jpg',
    quote:
      'The reasoning matrix keeps me honest. Instead of jumping to “it’s praxis,” I now list alternative explanations and plan the next observations.',
  },
  {
    name: 'Emily Hartmann',
    role: 'OT Student',
    location: 'Toronto, Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/cce8b9a3-ce17-4950-aff3-1cbee34cae22.jpg',
    quote:
      'As a student on placement, the case challenges gave me a structure to practice with. I finally feel like I know where to start with a motor planning case.',
  },
  {
    name: 'Carmen Ibáñez',
    role: 'Senior Pediatric OT',
    location: 'Valencia, Spain',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9540301f-ed6c-4f3b-8c94-4e09129af97d.jpg',
    quote:
      'After 18 years in practice I didn’t expect much new. The Function → Task → Performance → Measurement structure made my goals clearer for families.',
  },
];
